module.exports = __webpack_public_path__ + "img/eletrodutoAcessorioTampao1.73c3a6b8.png";